import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import { faqs } from '@/mocks/faqs';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import FAQSection from '@/components/feature/FAQSection';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function Home() {
  const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
  const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);

  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全_韩国漫画网站',
          description: '韩漫画免费阅读平台，支持下拉式观看，收录众多好看的韩国漫画大全，更新及时体验流畅。让您轻松追更和享受阅读乐趣。',
          url: 'https://www.hanmanhua.com/',
          inLanguage: 'zh-CN',
        }}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20vibrant%20colorful%20comic%20book%20panels%20with%20soft%20abstract%20shapes%20in%20warm%20orange%20and%20pink%20tones%2C%20modern%20minimalist%20background%20with%20subtle%20gradient%2C%20clean%20design%2C%20no%20text%2C%20atmospheric%20and%20dreamy%20mood%2C%20storytelling%20vibe&width=1920&height=1080&seq=hero-bg-comic&orientation=landscape"
            alt="韩漫画 - 韩国漫画免费阅读平台"
            title="韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-5xl font-bold font-heading text-background-50 mb-4 leading-tight">
              好看的韩国漫画大全，尽在韩漫画
            </h1>
            <p className="text-sm md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
              免费阅读最新最全韩漫，支持下拉式观看，更新及时体验流畅。<br className="hidden md:block" />
              浪漫爱情、奇幻冒险、动作热血、悬疑推理，各类韩漫一网打尽。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/langman"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3 bg-background-50/20 text-background-50 font-medium rounded-full text-sm whitespace-nowrap backdrop-blur-sm hover:bg-background-50/30 transition-colors cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900">
                漫画分类
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                探索不同风格的韩国漫画，找到你的最爱
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                    <i className={`${cat.icon} text-lg md:text-xl text-primary-600`}></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Comics */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900">
                  热门推荐
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  最受读者欢迎的韩国漫画
                </p>
              </div>
              <Link
                to="/category/langman"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
              {hotComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900">
                  最近更新
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  及时追更，不错过任何精彩章节
                </p>
              </div>
              <Link
                to="/category/langman"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                更多更新 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
              {latestComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900">
                为什么选择韩漫画
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                我们致力于为漫画爱好者打造最好的阅读体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { icon: 'ri-book-open-line', title: '海量资源', desc: '收录数千部热门韩国漫画，涵盖各种题材和风格，满足不同读者的喜好。' },
                { icon: 'ri-smartphone-line', title: '下拉式阅读', desc: '支持手机和电脑下拉式观看，无需翻页，阅读体验流畅自然。' },
                { icon: 'ri-timer-flash-line', title: '更新及时', desc: '紧跟原作连载进度，第一时间同步更新，让您永远走在追更最前线。' },
                { icon: 'ri-shield-check-line', title: '完全免费', desc: '所有漫画均可免费阅读，无需付费会员，真正实现零门槛畅读。' },
              ].map((feature, index) => (
                <div key={index} className="p-5 rounded-lg bg-background-50 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${feature.icon} text-xl text-accent-600`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 text-center">
              {[
                { value: '3000+', label: '漫画资源' },
                { value: '500万+', label: '月活跃用户' },
                { value: '99.9%', label: '服务可用率' },
                { value: '24h', label: '更新时效' },
              ].map((stat, index) => (
                <div key={index}>
                  <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500">{stat.value}</div>
                  <div className="mt-1 text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900">
                常见问题
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                关于韩漫画阅读的常见疑问解答
              </p>
            </div>
            <FAQSection faqs={faqs} />
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-14 md:py-20 bg-background-50 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20soft%20warm%20gradients%20in%20peach%20and%20cream%20tones%2C%20minimalist%20background%20texture%2C%20subtle%20overlapping%20shapes%2C%20clean%20modern%20design%2C%20no%20text&width=1920&height=600&seq=cta-bg-comic&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              立即开始你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-xl mx-auto">
              数千部热门韩漫等你来发现，浪漫、奇幻、悬疑、热血，总有一部适合你。现在就加入我们，开启免费阅读！
            </p>
            <Link
              to="/category/langman"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即探索 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}